import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link } from 'react-router';

import { MontgolfiereSchema, Montgolfieres } from '../../collections/montgolfieres/montgolfieres';


import {
  Well,
  Table,
  Button,
  Breadcrumb,
  Col,
  BPanel
} from '@sketchpixy/rubix';

import MgfTableComponent from '../common/mgfTable';

export default class PlanificationListPage extends React.Component {
  constructor(props) {
	  super(props);
	  this.state = {
		  //subscription: Meteor.subscribe('planifications'),
	  };

  }

  componentWillUnmount() {
	  //this.state.subscription.stop();
  }

  render() {
    return (
      <div> 
        <Breadcrumb>  
          <Breadcrumb.Item>
            Planifications
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            Liste des planifications
          </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/planifications/add"><Button bsStyle="success">Ajout simple</Button></Link>
            </Breadcrumb.Item>
             <Breadcrumb.Item>
              <Link to="/planifications/add-multiple"><Button bsStyle="success">Ajout multiple</Button></Link>
          </Breadcrumb.Item>
        </Breadcrumb>
        <BPanel header="Liste des planifications">
      			
        </BPanel>
      </div>
    );
  }
}

PlanificationListPage.propTypes = {
  planifications: React.PropTypes.array.isRequired,
};




/** WEBPACK FOOTER **
 ** ./src/universal/components/planifications/PlanificationListPage.js
 **/